'use strict';
import { ForgotPasswordBase } from './ForgotPasswordBase';
import Render  from './ForgotPasswordRender';

export default class ForgotPassword extends ForgotPasswordBase {
    render() {
        return Render.call(this, this.props, this.state);
    }
}
